import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var JobTriggerService = /** @class */ (function (_super) {
    tslib_1.__extends(JobTriggerService, _super);
    function JobTriggerService(http) {
        var _this = _super.call(this, http, MapperService.jobTriggerMap) || this;
        _this._endpoint = '/odata/JobTriggers';
        return _this;
    }
    return JobTriggerService;
}(ODataService));
export { JobTriggerService };
